<template>
  <div class="insurance-list-items">
    <img :src="icon" class="logo" />
    <div class="meta">
      <router-link :to="route" class="name">{{ title }}</router-link>
      <p class="desc">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: null,
      default: undefined,
    },
    subtitle: {
      type: null,
      default: undefined,
    },
    icon: {
      type: null,
      default: undefined,
    },
    route: {
      type: null,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 50px;

.insurance-list-items {
  display: flex;
  border-bottom: $border;

  > .logo {
    height: $logoSize;
    widows: $logoSize;
    margin: 10px;
  }
  > .meta {
    margin: 10px;
  }

  > .meta > .name {
    line-height: 1.6;
    display: inline-block;

    &:hover {
      color: black;
    }
  }
}
</style>
